import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #0E1F1F;
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 600px;
  border: 2px solid #284640;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 90vh;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    width: 95%;
    padding: 16px;
    border-radius: 12px;
    gap: 16px;
    margin: 16px;
    max-height: calc(100vh - 32px);
  }
  
  @media (max-width: 480px) {
    width: calc(100% - 24px);
    padding: 12px;
    margin: 12px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #838D90;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #172A2A;
    color: #FFFFFF;
  }
`;

const ModalTitle = styled.h2`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  margin: 0;
  word-break: break-word;
  
  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const ModalMessage = styled.p`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #838D90;
  margin: 0;
  line-height: 1.5;
`;

const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 24px;
  background-color: #172A2A;
  border-radius: 12px;
  border: 1px solid #284640;
`;

const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background-color: #172A2A;
  border-radius: 12px;
  border: 1px solid #284640;
`;

const InfoTable = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
`;

const InfoCard = styled.div`
  padding: 16px;
  background-color: #0E1F1F;
  border-radius: 8px;
  border: 1px solid #284640;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;


const CardTitle = styled.h4`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #24BA7D;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #284640;
  gap: 8px;
  
  &:last-child {
    border-bottom: none;
  }
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

const InfoLabel = styled.span`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #838D90;
  
  @media (max-width: 480px) {
    font-size: 12px;
    font-weight: 500;
  }
`;

const InfoValue = styled.span`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #FFFFFF;
  text-align: right;
  word-break: break-word;
  max-width: 60%;
  
  @media (max-width: 480px) {
    text-align: left;
    max-width: 100%;
    font-weight: 600;
  }
`;

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: #0E1F1F;
  border-radius: 8px;
  border: 1px solid #284640;
  gap: 12px;
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

const ActionButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid #24BA7D;
  background-color: transparent;
  color: #24BA7D;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    background-color: #24BA7D;
    color: #FFFFFF;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 14px;
    width: 100%;
    text-align: center;
  }
`;

const StatusContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  @media (max-width: 480px) {
    justify-content: space-between;
    width: 100%;
  }
`;

const LocationActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #284640;
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 16px;
  background-color: #24BA7D;
  color: #FFFFFF;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
`;



const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  
  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  @media (max-width: 480px) {
    padding: 14px 24px;
    font-size: 16px;
    width: 100%;
  }
  
  ${props => props.variant === 'primary' ? `
    background-color: #24BA7D;
    color: #FFFFFF;
    
    &:hover {
      background-color: #1E9A66;
    }
  ` : `
    background-color: transparent;
    color: #838D90;
    border: 1px solid #284640;
    
    &:hover {
      background-color: #172A2A;
      color: #FFFFFF;
    }
  `}
`;


interface ProductInfo {
  product_brand: string;
  product_model: string;
  product_color: string;
  product_condition: string;
  product_us_size: string;
  product_sku: string;
  product_location: {
    location: string;
    letter: string;
    number: number;
  };
  product_status: string;
  product_code: string;
  product_image: string;
  product_vendor: {
    username: string;
    telegram: string;
    vk: string;
  };
}

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  qrCode?: string;
  productInfo?: ProductInfo;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onChangeLocation?: () => void;
  onChangeStatus?: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  qrCode,
  productInfo,
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
  onConfirm,
  onCancel,
  onChangeLocation,
  onChangeStatus
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onCancel}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <CloseButton onClick={onCancel}>
            ✕
          </CloseButton>
        </ModalHeader>
        
        <ModalMessage>{message}</ModalMessage>
        
        {productInfo && (
          <ProductInfoContainer>
            <InfoTable>
              <StatusContainer>
                <StatusContent>
                  <CardTitle>Статус</CardTitle>
                  <StatusBadge>{productInfo.product_status}</StatusBadge>
                </StatusContent>
                {onChangeStatus && (
                  <ActionButton onClick={onChangeStatus}>
                    Изменить статус
                  </ActionButton>
                )}
              </StatusContainer>

              <InfoCard>
                <CardHeader>
                  <CardTitle>Местоположение</CardTitle>
                </CardHeader>
                <InfoRow>
                  <InfoLabel>Локация</InfoLabel>
                  <InfoValue>{productInfo.product_location?.location || 'Не указана'}</InfoValue>
                </InfoRow>
                <InfoRow>
                  <InfoLabel>Место</InfoLabel>
                  <InfoValue>{productInfo.product_location?.letter || ''}{productInfo.product_location?.number || ''}</InfoValue>
                </InfoRow>
                {onChangeLocation && (
                  <LocationActions>
                    <ActionButton onClick={onChangeLocation}>
                      Сменить место
                    </ActionButton>
                  </LocationActions>
                )}
              </InfoCard>

              <InfoCard>
                <CardHeader>
                  <CardTitle>Детали продукта</CardTitle>
                </CardHeader>
                <InfoRow>
                  <InfoLabel>Бренд</InfoLabel>
                  <InfoValue>{productInfo.product_brand}</InfoValue>
                </InfoRow>
                <InfoRow>
                  <InfoLabel>Модель</InfoLabel>
                  <InfoValue>{productInfo.product_model}</InfoValue>
                </InfoRow>
                <InfoRow>
                  <InfoLabel>Цвет</InfoLabel>
                  <InfoValue>{productInfo.product_color}</InfoValue>
                </InfoRow>
                <InfoRow>
                  <InfoLabel>Состояние</InfoLabel>
                  <InfoValue>{productInfo.product_condition}</InfoValue>
                </InfoRow>
                <InfoRow>
                  <InfoLabel>US размер</InfoLabel>
                  <InfoValue>{productInfo.product_us_size}</InfoValue>
                </InfoRow>
                <InfoRow>
                  <InfoLabel>SKU</InfoLabel>
                  <InfoValue>{productInfo.product_sku}</InfoValue>
                </InfoRow>
                {qrCode && (
                  <LocationActions>
                    <ActionButton onClick={() => window.open(qrCode, '_blank')}>
                      Открыть QR-код
                    </ActionButton>
                  </LocationActions>
                )}
              </InfoCard>
            </InfoTable>
          </ProductInfoContainer>
        )}
        
        <ButtonContainer>
          <Button variant="primary" onClick={onConfirm}>
            {confirmText}
          </Button>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ConfirmModal; 